import e from "@dialpad/dialtone-tokens/layered/themes/tokens-ceruleo-colors.css?inline";
//#region themes/ceruleo.js
var t = { brand: {
	css: e,
	name: "ceruleo"
} };
//#endregion
export { t as default };
